import { render, staticRenderFns } from "./TheList.vue?vue&type=template&id=0c6d4fbe&scoped=true"
import script from "./TheList.vue?vue&type=script&lang=js"
export * from "./TheList.vue?vue&type=script&lang=js"
import style0 from "./TheList.vue?vue&type=style&index=0&id=0c6d4fbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d4fbe",
  null
  
)

export default component.exports